var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurtainsOuter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 342"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "curtains-outer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 45",
    fill: "#1d1d1d",
    d: "M0 0h108.961v342H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "curtains-outer_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 45",
    fill: "#1d1d1d",
    d: "M0 0h107.667v342H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 85",
    transform: "translate(231.039)",
    clipPath: "url(#curtains-outer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 247",
    d: "M103.162 339.761c-15.392-37.265-19-77.467-4.518-129.71 3.809-10.084 4.546-10.9 9.405-20.054.572-1.076.748-2.256-.421-2.6-22.723-6.781-41.267-21.617-55.384-40.44-17.353-19.698-34.89-55.327-41.839-85.727a266.756 266.756 0 01-8.72-59.42C1.549-.594-.13-.612.005 1.81c2 36.09 10.07 72.057 24.747 105.017 11.375 25.552 28.372 47.16 49.913 64.985 10.269 6.406 22.805 13.768 32.963 16.647-.366-.923.369.92 0 0-18.5 34.85-23.407 79.107-16.034 117.866 2.26 11.883 5.121 23.517 9.728 34.669.907 2.2 2.761 1 1.84-1.233",
    fill: "#1d1d1d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 85",
    clipPath: "url(#curtains-outer_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 247",
    d: "M5.729 339.761c15.209-37.265 18.77-77.467 4.464-129.71C6.43 199.966 5.701 199.152.9 190c-.566-1.076-.74-2.256.416-2.6 22.453-6.776 40.778-21.612 54.727-40.435 17.148-19.7 32.68-51.228 39.548-81.628 5.343-20.279 9.094-43.674 9.86-63.519.134-2.4 2.345-2.422 2.211 0-1 18.191-3.245 25.382-6.256 46.35-4.025 17.388-11 42.32-18.2 58.668-11.24 25.552-28.035 47.16-49.321 64.985-10.145 6.397-22.532 13.759-32.569 16.638.362-.923-.364.92 0 0 18.277 34.85 23.129 79.107 15.847 117.866-2.233 11.883-5.06 23.517-9.612 34.669-.9 2.2-2.728 1-1.818-1.233",
    fill: "#1d1d1d"
  })))));
}

export default __webpack_public_path__ + "0b193d11408cc4c9df68ced2e4c800ac.svg";
export { SvgCurtainsOuter as ReactComponent };